import type { SVGProps } from 'react';

export type FlagFRProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const FlagFR = ({ size = 60, ...rest }: FlagFRProps) => (
  <svg
    width={size}
    height={size * (40 / 60)}
    viewBox="0 0 60 40"
    role="img"
    aria-label="France"
    {...rest}
  >
    <title>France</title>
    <rect x="1" y="1" width="19.333" height="38" fill="#1B3380" />
    <rect x="20.333" y="1" width="19.333" height="38" fill="#F4ECDC" />
    <rect x="39.667" y="1" width="19.333" height="38" fill="#C8362C" />
    <rect
      x="1"
      y="1"
      width="58"
      height="38"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth="1.5"
    />
  </svg>
);
